import React from "react";
import { lightThemeColors } from "../../assets/style/colors";
import styled from "styled-components";
import GrovsComparationTable from "./GrovsComparationTable";

const GrovsDeliver = () => {
  return (
    <FullPageContainer>
      <Container id={"grovsDeliver"}>
        <Line>
          <TextWrapper>
            <Title>Grovs delivers more features for less.</Title>
            <Subtitle>
              Enterprise-grade growth tools at up to 60% less cost than legacy
              platforms—no trade-offs, no hidden fees, no add-ons.
            </Subtitle>
          </TextWrapper>
        </Line>
        <GrovsComparationTable />
      </Container>
    </FullPageContainer>
  );
};

export default GrovsDeliver;

const FullPageContainer = styled.div`
  display: flex;
  width: 100%;
  background: ${lightThemeColors.lightColor};
  position: relative;
`;

const Container = styled.div`
  width: 100%;
  max-width: 1512px;
  margin-left: auto;
  margin-right: auto;
  z-index: 1;
  display: flex;
  flex-direction: column;
  padding: 0px 80px 100px 80px;
  gap: 100px;
  @media (max-width: 990px) {
    padding: 20px;
    gap: 30px;
  }
`;

const Title = styled.h1`
  color: ${lightThemeColors.darkColor};
  font-size: 36px;
  font-weight: 700;
  line-height: 46px;
  text-align: center;
  @media (max-width: 990px) {
    font-size: 30px;
    line-height: 36px;
    text-align: center;
  }
`;
const Subtitle = styled.p`
  color: ${lightThemeColors.darkColorFaded};
  font-size: 18px;
  font-weight: 400;
  line-height: 28px;
  text-align: center;
`;

const TextWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;
  gap: 30px;
  max-width: 850px;
  margin: auto;
`;

const Line = styled.div`
  display: flex;
  align-items: center;
  gap: 25px;
  @media (max-width: 990px) {
    gap: 30px;
    flex-direction: column;
  }
`;
